import { CredentialDefinitionType } from 'src/app/shared/models/credential/credential-definition.model';

interface IInvoiceLineItemModel {
  amount: number;
  label: string;
  feeDefinitionId: string;
}

/** may or may not be a paid invoice */
export class InvoiceModel {
  id: string;
  orderNumber: string;
  invoiceNumber: string;
  dueDate: string;
  paymentType: string;
  paymentTypeDisplay: string;
  paymentDisplayHighlight: string;
  invoiceStatus: InvoiceStatus;
  /** shouldn't need directly. Will be in the paymentDisplayHighlight or paymentTypeDisplay field */
  checkNumber: string;
  /** shouldn't need directly. Will be in the paymentDisplayHighlight or paymentTypeDisplay field */
  nameOnCheck: string;
  paymentLink: string;
  completionDate: string;
  amount: string;
  lastActionDate: string;
  paymentResult: PaymentResult;
  receiptNumber: string;
  failureReason: string;
  /** shouldn't need directly. Will be in the paymentDisplayHighlight or paymentTypeDisplay field */
  paymentLastFour: string;
  /** shouldn't need directly. Will be in the paymentDisplayHighlight or paymentTypeDisplay field */
  institution: string;
  invoiceType: CredentialDefinitionType;
  entityId: string;
  invoiceId: string;
  createdOn: string;
  /**for a team invoice this is the team's name. For a person invoice this is the person's full name */
  entityName: string;
  invoiceLineItems: IInvoiceLineItemModel[];
}

export const getInvoiceStatusIcon = (invoiceModel: InvoiceModel): string => {
  switch (InvoiceStatus[invoiceModel.invoiceStatus]) {
    case InvoiceStatus.Paid:
      return 'check_circle';
    case InvoiceStatus.Open:
      return 'schedule';
    case InvoiceStatus.Void:
      return 'cancel';
    case InvoiceStatus.OverDue:
      return 'error';
  }
};

export enum InvoiceStatus {
  Paid = 'Paid',
  Open = 'Open',
  Void = 'Void',
  OverDue = 'Past due'
}

export enum PaymentResult {
  Success = 'Success',
  Failed = 'Failed'
}
